import React, { useEffect, useState } from 'react';
import { FiEdit } from 'react-icons/fi';
import { getTranslationKey } from '../../modules/utils';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getUser } from '../../modules/selectors';
import { Title } from './common';
import { isTaxConfirmed } from '../../common/is-tax-confirmed';
import { DisplayCard, Header } from './DisplayCard';
import { ShopTaxSetupForm } from '../../components/ShopTaxSetup/ShopTaxSetupForm';
import media from '../../assets/css/media';

const FiEditBtn = styled(FiEdit)`
  cursor: pointer;
  align-self: flex-start;
  min-width: 20px;
  min-height: 20px;
`;

const FormWrapper = styled.div`
  width: 50%;
  @media all and (max-width: ${media.mobile}) {
    width: 100%;
  }
`;

export const TaxSettingsTab = () => {
  const { taxSettings, currency } = useSelector(getUser);
  const isConfirmed = isTaxConfirmed(taxSettings);
  const [showForm, setShowForm] = useState(!isConfirmed);

  useEffect(() => {
    if (isConfirmed) {
      setShowForm(false);
    }
  }, [isConfirmed]);

  return (
    <div className="new-design">
      <Title className="mb-4">{getTranslationKey('shop.paymentSettings.taxSettingsTitle')}</Title>
      <div
        className="mb-5"
        dangerouslySetInnerHTML={{
          __html: getTranslationKey('shop.paymentSettings.taxSettingsInfo')
        }}
      />
      <FormWrapper>
        {showForm ? (
          <ShopTaxSetupForm
            isFullForm
            closeForm={isConfirmed ? () => setShowForm(false) : undefined}
          />
        ) : (
          <DisplayCard className="animated fadeIn">
            <Header>
              <div>
                {taxSettings?.smallBusinessOwner ? (
                  <div>{getTranslationKey('shop.taxConfig.businessCheckboxLabel')}</div>
                ) : (
                  <div>
                    {taxSettings?.endCustomerPercent}%{' '}
                    {getTranslationKey('shop.taxConfig.taxRateLabel')}
                  </div>
                )}
                <div>{currency}</div>
                {!!taxSettings?.vatId && <div>{taxSettings.vatId}</div>}
                {!!taxSettings?.taxId && <div>{taxSettings.taxId}</div>}
                {!!taxSettings?.registrationNumber && <div>{taxSettings.registrationNumber}</div>}
                {!!taxSettings?.commercialRegister && <div>{taxSettings.commercialRegister}</div>}
              </div>
              <FiEditBtn size={20} onClick={() => setShowForm(true)} />
            </Header>
          </DisplayCard>
        )}
      </FormWrapper>
    </div>
  );
};
